import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, token } = useAuth();
  if (!user && !token) {
    // user is not authenticated
    return <Navigate to="/login" />;
  }
  return children;
};